// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SchemaMigrations_RunResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/schema_migrations/run — SchemaMigrator::run():
 * outcome applied | error | already_running (another runner holds the lock).
 */
import type { SchemaMigrations_FailureRow } from './SchemaMigrations_FailureRow'
import type { SchemaMigrations_RunMigrationRow } from './SchemaMigrations_RunMigrationRow'
import type { SchemaMigrations_RunModelRow } from './SchemaMigrations_RunModelRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SchemaMigrations_RunResponseDados {
outcome: string
run_id: string
actor: string
total: number
synced: number
ddl_applied: number
extra: number
no_schema: number
migrations_applied: number
ledger_rows: number
ms: number
models: SchemaMigrations_RunModelRow[]
migrations: SchemaMigrations_RunMigrationRow[]
failures: SchemaMigrations_FailureRow[]
}

export type SchemaMigrations_RunResponse = ApiResponse<SchemaMigrations_RunResponseDados>;

registerResponseContract('SchemaMigrations_RunResponse', {
  outcome:            { type: 'string',  required: true },
  run_id:             { type: 'string',  required: true },
  actor:              { type: 'string',  required: true },
  total:              { type: 'number',  required: true },
  synced:             { type: 'number',  required: true },
  ddl_applied:        { type: 'number',  required: true },
  extra:              { type: 'number',  required: true },
  no_schema:          { type: 'number',  required: true },
  migrations_applied: { type: 'number',  required: true },
  ledger_rows:        { type: 'number',  required: true },
  ms:                 { type: 'number',  required: true },
  models: {
    type: 'array',
    required: true,
    items: {
      model:       { type: 'string',  required: true },
      state:       { type: 'string',  required: true },
      ddl_applied: { type: 'number',  required: false },
      extra:       { type: 'boolean', required: false },
      ms:          { type: 'number',  required: false },
    },
  },
  migrations: {
    type: 'array',
    required: true,
    items: {
      id:          { type: 'string',  required: true },
      state:       { type: 'string',  required: true },
      applied_now: { type: 'boolean', required: false },
      ms:          { type: 'number',  required: false },
    },
  },
  failures: {
    type: 'array',
    required: true,
    items: {
      model: { type: 'string',  required: true },
      error: { type: 'string',  required: true },
      phase: { type: 'string',  required: false },
    },
  },
})
